import React from 'react';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import DotsSpinnerIcon from '@components/DotsSpinner';
import styles from './DotLoadingSpinner.module.scss';
const DotsLoadingSpinner = ({ className, ...props }) => {
    const [rootClass, getChildClass] = getClassName({ rootClass: 'dotsLoadingSpinner', styles, className });
    return (<div className={rootClass}>
            <DotsSpinnerIcon {...props} className={getChildClass('spinner')}/>
        </div>);
};
DotsLoadingSpinner.displayName = 'DotsLoadingSpinner';
export default DotsLoadingSpinner;
